import {
  LOAD_CURRENT_USER,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT_SUCCESS,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGOUT_FAIL,
  USER_INITIATED_LOGOUT
  
} from "../actionTypes";
import Cookies from "js-cookie";

const initialState = {
  token: Cookies.get("token"),
  currentUser: null,
  isLogged: Boolean(Cookies.get("token")),
  isAdmin: Cookies.get("role") === "admin",
  isCompany: Boolean(Cookies.get("company")),
  userInitiatedLogout: false,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CURRENT_USER:
    case LOGIN_SUCCESS:
    case REGISTER_SUCCESS:
      Cookies.set("token", action.token);
      Cookies.set("role", action.user.role);
      return {
        ...state,
        token: action.token,
        currentUser: action.user,
        isLogged: true,
        isAdmin: action.user.role === "admin",
        isCompany: Cookies.get("company") ? true : false 
      };
    case LOGIN_FAIL:
    case REGISTER_FAIL:
      Cookies.remove("role");
      Cookies.remove("company");
      Cookies.remove("company_id");
      return {
        ...state,
        token: null,
        currentUser: null,
        isLogged: false,
        isAdmin: false,
        isCompany: false
      };
    case LOGOUT_SUCCESS:
      Cookies.remove("token");
      Cookies.remove("role");
      Cookies.remove("company");
      Cookies.remove("company_id");
      return {
        ...state,
        token: null,
        currentUser: null,
        isLogged: false,
        isAdmin: false,
        isCompany: false,
        userInitiatedLogout: true,
      };
    case USER_INITIATED_LOGOUT:
      return {
        ...state,
        userInitiatedLogout: true,
      };
    case LOGOUT_FAIL:
    default:
      return state;
  }
};

export default authReducer;
